import React from 'react';
import { IMAGES } from '../data';
import { Reveal } from './Reveal';
const PROMISE = ['Smak', 'Kvalitet', 'Hantverk'];
export function Vision() {
  return <section className="w-full bg-warm py-28 md:py-40" data-id="element-204" data-mp="1g71r6xp9cpv3">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 md:grid-cols-2 md:gap-24 md:px-10" data-id="element-205" data-mp="1c8ce7684tabz">
        <Reveal data-id="element-206" data-mp="179hm1do9y9f7">
          <div className="overflow-hidden rounded-sm" data-id="element-207" data-mp="17a15iytkp5vc">
            <img src={IMAGES.dessertTable} alt="Elegant dessertbord med tårtor och bakverk" className="h-full w-full object-cover" data-id="element-208" data-mp="23yqoksgxs4iw" />
          </div>
        </Reveal>

        <Reveal delay={0.15} data-id="element-209" data-mp="1uwheu4thsf6k">
          <p className="mb-6 text-[12px] uppercase tracking-wide3 text-terrakotta" data-id="element-210" data-mp="1uzvhle62iqej">Vision</p>
          <h2 className="font-display text-3xl font-light leading-tight text-brun md:text-4xl" data-id="element-211" data-mp="1pyfu7fgf47sz">
            Smålands främsta matupplevelser.
          </h2>
          <p className="mt-8 text-lg leading-relaxed text-brun-soft" data-id="element-212" data-mp="ej9d8cfmp1da">
            Boka regionens bästa bagare, kockar och cateringföretag direkt genom oss. Ett gemensamt löfte för alla dina event.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-x-4 gap-y-2" data-id="element-213" data-mp="2a05cssl4dw2x">
            {PROMISE.map((word, i) => <React.Fragment key={word} data-id="element-214" data-mp="1w15r9tswlxaz" data-mpi={i}>
                <span className="font-display text-2xl italic text-skog md:text-3xl" data-id="element-215" data-mp="2108mynmzur6a">{word}.</span>
                {i < PROMISE.length - 1 && <span className="text-terrakotta" data-id="element-216" data-mp="1majiaifp0519">/</span>}
              </React.Fragment>)}
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-4" data-id="element-217" data-mp="1r3vsvonjebb0">
            <a href="/utbud" className="inline-block rounded-full bg-skog px-8 py-4 text-sm uppercase tracking-wide2 text-warm transition-colors hover:bg-brun" data-id="element-218" data-mp="1dbpcq2kdw4bk">
              Se utbud
            </a>
            <a href="/bestall" className="inline-block rounded-full border border-brun/20 px-8 py-4 text-sm uppercase tracking-wide2 text-brun transition-colors hover:bg-brun hover:text-warm" data-id="element-219" data-mp="13cglviktf5tf">
              Boka nu
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}